import { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';

import { GrowthDashboardModal } from '@/components/growth/growth-dashboard-modal';
import { useAppTheme } from '@/theme/app-theme';

/**
 * The dashboard route. The body mounts with it — no deferral, no animation.
 *
 * Build 12 opened and closed this slowly because the route is a modal whose
 * body was ALSO an RN `<Modal>`: two presentations, two dismissals. Removing
 * the inner one fixed closing outright and still stands
 * (`dashboard-presentation.test.ts`).
 *
 * Opening was then blamed on this 3,000-line tree mounting in front of the
 * slide, and the body was deferred behind `InteractionManager`. Build 14
 * measured it: `dashboard.route.mount` to `dashboard.body.painted` is about
 * TEN MILLISECONDS. Nothing was blocking anything — the slide itself was the
 * jank — so the deferral bought nothing and has gone, along with the slide.
 * Goals and Reflections open instantly as plain modals and feel better; an
 * instant appearance cannot stutter.
 */
export default function DashboardScreen() {
  const router = useRouter();
  const { colors } = useAppTheme();

  const closeDashboard = useCallback(() => {
    if (router.canGoBack()) {
      router.back();
      return;
    }

    router.replace('/profile');
  }, [router]);

  return (
    <View
      style={[
        styles.screen,
        { backgroundColor: colors.background },
      ]}>
      <GrowthDashboardModal
        visible
        onClose={closeDashboard}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
  },
});
